import { Button, TextInput } from '@mantine/core';
import { isEmail, useForm } from '@mantine/form';
import React from 'react';
import styled from 'styled-components';
import { Colors } from '../patterns/Colors';

export interface RegisterFormValues {
    name: string;
    email: string;
}

interface Props {
    initialEmail?: string;
    onSubmit: (values: RegisterFormValues) => void;
    loading: boolean;
}

export const RegisterForm = ({ initialEmail = '', onSubmit, loading }: Props) => {

    const form = useForm<RegisterFormValues>({
        mode: 'uncontrolled',
        initialValues: {
            name: '',
            email: initialEmail,
        },
        validate: {
            name: value => value.trim() ? null : 'Name is required',
            email: isEmail('Please enter a valid email'),
        },
    });

    return <Form onSubmit={form.onSubmit(onSubmit)}>
        <Heading>Register a new account</Heading>
        <Subhead>We recommend using your work email.</Subhead>
        <TextInput
            type="text"
            placeholder="Your name"
            autoFocus
            disabled={loading}
            w="100%"
            mb="md"
            {...form.getInputProps('name')}
        />

        <TextInput
            type="email"
            placeholder="you@company.com"
            disabled={loading}
            w="100%"
            mb="md"
            {...form.getInputProps('email')}
        />

        <Button
            type="submit"
            loading={loading}
            color="primary"
            size="sm"
            fullWidth
            mb="md"
        >
            Continue
        </Button>
    </Form>;
};

const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

const Heading = styled.h1`
    font-size: 1.25rem;
    font-weight: 500;
    color: ${Colors.text};
    margin: 0 0 0.5rem;
`;

const Subhead = styled.p`
    font-size: 0.875rem;
    color: ${Colors.text};
    opacity: 0.7;
    margin: 0 0 1rem;
`;
